import { GraphQLClient } from "graphql-request";
import constants from "./constants";

const client = new GraphQLClient(constants.shared.apiUrl);

export default client;
